import React from "react";

const Table = () => {
  return (
    <>
      <div className="h-12 flex gap-5 items-center text-sidenavInactive font-Lato font-semibold text-sm">
        <input
          type="checkbox"
          className="w-5 h-5 outline-none border-[0.5px] border-[#DEE2F3] focus:outline-none"
        />

        <div className="w-28">Date</div>
        <div className="w-[150px] xl:w-[225px]">Reference ID</div>
        <div className="w-[150px] xl:w-[225px]">Item Name</div>
        <div className="">Status</div>
      </div>
    </>
  );
};

export default Table;
